import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router';
import { DeviceType } from '../devicetype/devicetype';
import { DeviceTypeService } from '../../services/devicetype.service';
import { TestGroupService } from '../../services/testgroup.service';
import { AssetService } from '../../services/asset.service';
import { ApiResponse } from '../../admin/apiresponse';
import { TestGroup } from '../models/testgroup';
import { TestGroupSystemsStatus } from '../models/testgroupsystemsstatus';
import { FirmwareAsset } from '../models/firmwareasset';
import { Observable, Subscription } from 'rxjs';

@Component({    
    template: require('./admin.testgroup.add.component.html'),
    providers: [DeviceTypeService, TestGroupService, AssetService]
})

export class TestGroupAddComponent implements OnInit {
    public queryInProgress: boolean;
    public testGroupForm: FormGroup;
    public submitted: boolean;
    public apiResponse: ApiResponse;
    public apiResponseTestGroup: ApiResponse;
    public apiResponseAssetVersion: ApiResponse;
    public apiResponseSystems: TestGroupSystemsStatus[];
    public assetList: FirmwareAsset[] = [];
    public assetsUnique: string[] = [];
    public assetVersions: string[] = [];
    public assetVersionList: any[] = [];
    public assetTypeAlreadySelected: boolean;
    public editMode: boolean;
    public noAssetsInEditMode: boolean;
    public assetsAndVersionsUpdated: boolean;

    public deviceTypes: DeviceType[];

    private deviceType: any;
    private testGroupName: any;
    public busySub: Subscription;

    constructor(private fb: FormBuilder, private devicetypeService: DeviceTypeService, private testGroupService: TestGroupService, private assetService: AssetService,
        private route: ActivatedRoute) {

    }


    ngOnInit() {
       this.editMode = false;
       this.buildForm();
       this.route.params.subscribe(params => {
           this.deviceType = params["deviceType"];
           this.testGroupName = params["testGroupName"];

           if (this.deviceType && this.testGroupName) {
               this.editMode = true;
               this.queryInProgress = true;
               this.populateDataForEdit(this.deviceType, this.testGroupName);               
           }
        });
    }

    buildForm(): void {
        this.testGroupForm = this.fb.group({
            devicetype: [''],
            name: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
            description: ['', Validators.compose([Validators.required, Validators.maxLength(1000)])],
            systemids: [''],
            assettype: [''],
            version: ['']
        });

        this.getDeviceTypes();       
    }


    createTestGroup(testGroup: TestGroup) {
        this.resetCreateResponse();
        this.submitted = true;
        testGroup.assetversionlists = this.assetVersionList;
        this.busySub = this.testGroupService.createTestGroup(testGroup)
            .subscribe(
            success => this.setCreateResponse(success),
            error => this.handleError(<any>error)
            );
    }

    updateTestGroup() {
        this.submitted = true;
        this.resetCreateResponse();
        let testGroup = <TestGroup>this.testGroupForm.getRawValue();
        testGroup.assetversionlists = this.assetVersionList;
        this.busySub = this.testGroupService.updateTestGroup(testGroup)
            .subscribe(
            success => this.setCreateResponse(success),
            error => this.handleError(<any>error)
            );
    }

    getDeviceTypes() {
        this.busySub = this.devicetypeService.getDeviceTypes()
            .subscribe(
            success => this.setGetResponse(success),
            error => this.handleError(<any>error)
            );                
    }

    getAssetsOfDeviceType(deviceType: string) {
        if (!this.editMode) {
            this.assetVersionList = [];
        }
        this.busySub = this.assetService.GetAssetsByDeviceType(deviceType)
            .subscribe(
            success => this.populateAssets(success),
            error => this.handleError(<any>error)
            );       
    }

    populateAssets(resp: any) {
        this.assetVersions = [];
        this.assetList = resp.data;
        this.assetsUnique = TestGroupAddComponent.getUniqueValues(resp.data, 'AssetType');
    }

    populateVersions(assetType: string) {
        this.assetTypeAlreadySelected = false;
        this.assetVersions = TestGroupAddComponent.getUniqueValuesFor(this.assetList, 'Version', 'AssetType', assetType);
    }

    addAssetVersionSelection(testGroup: TestGroup) {
        if (testGroup.assettype == '' || testGroup.version == '') {
            return;
        }
        let exists = false;
        this.noAssetsInEditMode = false;
        //check if the asset type already in the list
        for (var i = 0; i < this.assetVersionList.length; i++) {
            var datum = this.assetVersionList[i];
            if (datum.AssetType === testGroup.assettype) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            this.assetTypeAlreadySelected = false;
            this.assetsAndVersionsUpdated = true;
            this.assetVersionList.push({
                AssetType: testGroup.assettype,
                Version: testGroup.version
            });
        } else {
            this.assetTypeAlreadySelected = true;
        }
    }

    removeItemFromSelectionList(index: number) {
        this.assetVersionList.splice(index, 1);
        this.assetTypeAlreadySelected = false;
        this.assetsAndVersionsUpdated = true;
    }

    populateDataForEdit(deviceType: string, testGroupName: string) {
        this.busySub = this.testGroupService.getTestGroupDetails(deviceType, testGroupName)
            .subscribe(
            success => this.setEditDataRetrievalStatus(success),
            error => this.handleError(<any>error)
            );
    }

    static getUniqueValues(arr, prop) {
        return arr.map(function (e) { return e[prop]; }).filter(function (e, i, a) {
            return i === a.indexOf(e);
        });
    }

    static getUniqueValuesFor(arr, prop, conditionProp, conditionPropVal) {
        return arr.map(function (e) { if (e[conditionProp] === conditionPropVal) { return e[prop]; } }).filter(function (e, i, a) {
            if (e != undefined) {
                return i === a.indexOf(e);
            }
        });
    }

    setGetResponse(resp: ApiResponse) {
        this.queryInProgress = false;
        this.apiResponse = resp;
        this.deviceTypes = resp.data || [];        
        if (this.editMode)
        {
           this.testGroupForm.controls['devicetype'].setValue(this.deviceType);                                    
        }  
    }

    setCreateResponse(resp: any) {
        this.apiResponseTestGroup = resp.testGroupResponse;
        this.apiResponseAssetVersion = resp.assetResponse;
        this.apiResponseSystems = resp.systemResponse;
        this.submitted = false;
    }

    resetCreateResponse() {
        this.apiResponseTestGroup = undefined;
        this.apiResponseAssetVersion = undefined;
        this.apiResponseSystems = undefined;
    }


    setEditDataRetrievalStatus(resp: ApiResponse) {
        this.testGroupForm.patchValue({
            devicetype: resp.data.DeviceType,
            name: resp.data.Name,
            description: resp.data.Description,
            systemids: resp.data.Systems.join() || ''
        });        
        this.testGroupForm.controls['devicetype'].disable();
        this.testGroupForm.controls['name'].disable();
        this.testGroupForm.controls['description'].disable();

        this.assetVersionList = resp.data.Versions || [];
        if (this.assetVersionList.length == 0) {
            this.noAssetsInEditMode = true;
        }
        else {
            this.noAssetsInEditMode = false;
        }
        this.getAssetsOfDeviceType(resp.data.DeviceType);
    }

    private handleError(resp: ApiResponse) {
        console.log(resp);
    }
}




// WEBPACK FOOTER //
// ./app/admin/testgroup/admin.testgroup.add.component.ts